
<div *ngIf="showWarningIcon" class="position-fixed rounded-circle d-flex justify-content-center align-items-center shadow warning-btn" (click)="onWarningIconClick()">

  <svg class="warning-svg" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <path class="svg-triangle" d="M1 21h22L12 2 1 21z"/>
    <g class="svg-exclamation">
      <path d="M13 16h-2v-6h2v6z"/>
      <path d="M13 8h-2V6h2v2z"/>
    </g>
  </svg>
</div>
